(() => {
  if (window.fsCommerce || document.documentElement.lang !== 'en') return;
  const element = document.getElementById('fs-commerce-context');
  if (!element) return;
  let config;
  try { config = JSON.parse(element.textContent); } catch (_) { return; }
  if (!config || !Array.isArray(config.cart)) return;
  const preview = () => window.Shopify?.designMode || window.Shopify?.theme?.role !== 'main';
  const allowed = () => !preview() && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const capture = (event, properties = {}) => {
    if (!allowed()) return false;
    const data = {store_key: 'formula-swiss-int', market_language: 'en', language: 'en', currency: config.currency, ...properties};
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event, ...data});
      window.posthog?.capture(event, {...data, $current_url: location.origin + location.pathname, $pathname: location.pathname, $referrer: ''});
    } catch (_) {}
    return true;
  };
  let cartSnapshotStale = false;
  const clearPending = () => { try { sessionStorage.removeItem('fs-pending-cart-add'); } catch (_) {} };
  // A marker is evidence only on the immediate cart landing with analytics consent.
  if (config.page_type !== 'cart' || !allowed()) clearPending();
  const added = (response, quantity, source) => {
    cartSnapshotStale = true;
    clearPending();
    const items = response.items || [response];
    for (const item of items) {
      const count = Math.max(1, Number(quantity || item.quantity) || 1);
      if (!item.variant_id || !item.product_id) continue;
      capture('fs_add_to_cart', {product_id: String(item.product_id), variant_id: String(item.variant_id), quantity: count, value: Number(item.final_price ?? item.price ?? 0) * count / 100, source});
    }
  };
  window.fsCommerce = {capture, added};
  let viewed = false;
  const pageView = () => {
    if (viewed || !allowed()) return;
    viewed = true;
    if (config.page_type === 'collection') capture('fs_collection_viewed', {collection_id: String(config.collection_id)});
    if (config.page_type === 'product') capture('fs_product_viewed', {product_id: String(config.product_id), variant_id: document.querySelector('product-form input[name="id"]')?.value || ''});
    if (config.page_type === 'cart') capture('fs_cart_viewed', {item_count: config.cart.reduce((count, item) => count + item.quantity, 0)});
    if (config.page_type === 'search') {
      const query = new URLSearchParams(location.search).get('q') || '';
      const normalized = query.toLowerCase().replace(/-/g, ' ').trim();
      const special = document.querySelector('[data-fs-search-count], [data-fs-thc-search-count]');
      const count = special ? Number(special.dataset.fsSearchCount ?? special.dataset.fsThcSearchCount) : config.result_count;
      const intent = special?.dataset.fsSearchKind ? special.dataset.fsSearchKind.toLowerCase() : /^(?:thc free|0(?:\.0)?% thc|zero thc)(?: cbd(?: oil)?)?$/.test(normalized) ? 'thc_free' : 'other';
      const properties = {result_count: count, query_length: query.length, search_intent: intent};
      capture('fs_search_results_viewed', properties);
      if (count === 0) capture('fs_search_no_results', properties);
    }
    try {
      const pending = JSON.parse(sessionStorage.getItem('fs-pending-cart-add') || 'null');
      if (pending && config.page_type === 'cart') {
        sessionStorage.removeItem('fs-pending-cart-add');
        const matching = config.cart.filter(item => String(item.variant_id) === pending.variant_id);
        const total = matching.reduce((count, item) => count + item.quantity, 0);
        const age = Date.now() - pending.at;
        if (matching.length === 1 && Number.isInteger(pending.before) && Number.isInteger(pending.quantity) && pending.quantity > 0 && pending.before >= 0 && age >= 0 && age < 120000 && total === pending.before + pending.quantity) added(matching[0], pending.quantity, pending.source);
      }
    } catch (_) {}
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!allowed() || !(form instanceof HTMLFormElement)) return;
    if (event.submitter?.name === 'checkout') {
      capture('fs_checkout_clicked', {source: 'cart'});
      return;
    }
    if (form.closest('product-form')) return;
    const action = new URL(form.action, location.href);
    if (action.origin !== location.origin || !/\/cart\/add(?:\.js)?$/.test(action.pathname)) return;
    const data = new FormData(form);
    const id = String(data.get('id') || '');
    const quantity = Math.max(1, Number(data.get('quantity')) || 1);
    const source = form.closest('[data-oil-comparison]') ? 'comparison' : 'collection';
    if (!id || event.defaultPrevented) return;
    capture('fs_add_to_cart_intent', {variant_id: id, quantity, source});
    clearPending();
    if (cartSnapshotStale) return;
    try { sessionStorage.setItem('fs-pending-cart-add', JSON.stringify({variant_id: id, quantity, before: config.cart.filter(item => String(item.variant_id) === id).reduce((n, item) => n + item.quantity, 0), source, at: Date.now()})); } catch (_) {}
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (link && new URL(link.href).origin === location.origin && /\/checkout\/?$/.test(new URL(link.href).pathname)) capture('fs_checkout_clicked', {source: 'checkout_link'});
  });
  document.addEventListener('visitorConsentCollected', () => { if (!allowed()) clearPending(); pageView(); });
  window.addEventListener('load', pageView, {once: true});
  pageView();
})();
